/* eslint-disable linebreak-style */
import React from 'react';

export default function RequiredFiled() {
  return <span className="required_maark"> *</span>;
}
